export default __webpack_public_path__ + "static/media/blank.e540a116.jpg";